'use client';

import { cx } from 'class-variance-authority';
import ReactMarkdown, { Components } from 'react-markdown';
import { Code } from './Code';
const components: Partial<Components> = {
  code: Code
};
interface MarkdownProps {
  children?: string | null;
  className?: string;
}
const classes = {
  wrapper: 'relative',
  prose: 'prose prose-a:font-medium prose-a:text-sm prose-li:font-medium prose-li:text-secondary-readable prose-li:text-sm prose-p:text-sm prose-p:text-secondary-readable prose-p:font-medium prose-p:pr-4 prose-p:text-pretty prose-p:[overflow-wrap:anywhere]'
};
export function Markdown({
  children,
  className = classes.prose
}: MarkdownProps) {
  return <ReactMarkdown className={cx(classes.wrapper, className)} components={components}>
      {children}
    </ReactMarkdown>;
}